export default __webpack_public_path__ + "e18927529de6c2c862774e2321d331ec.png";